module.exports = __webpack_public_path__ + "assets/logo.b2092002.svg";